import { TechnicalFaultTypes } from "../Constants";

export const ModifyTechnicalFaultType = {
  name: "technical-fault-type",
  component: "MainPanel",
  layout: "main-panel x-large",
  mode: "visible",
  text: "technicalFault.type",
  showOn: [
    { state: "editState", value: "technical-fault-type", operator: "is" },
  ],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "technical-fault-types",
      component: "ButtonGroup",
      layout: "button-group",
      mode: "visible",
      showOn: [true],
      options: {
        value: "subType",
        children: TechnicalFaultTypes,
        layout: "type-button",
        prefix: "technicalFault",
        type: "edit",
        oneActive: true,
      },
      actionGroups: [
        {
          actions: [
            { action: "clearData", value: [{ option: "offensiveFoul" }], type: "edit" },
            { action: "sendEvent", value: "edit", type: "edit" },
            {
              action: "deleteFromPlay",
              value: "foul",
              subType: "drawn",
              type: "edit",
              options: ["all"],
              eventOptions: [{ option: "offensive", value: true }],
            },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [
            { item: "subType", value: "steal", event: "edit", operator: "not" },
            { item: "subType", value: "offensiveFoul", event: "edit", operator: "not" },
          ],
        },
        {
          actions: [
            { action: "saveData", value: "ruleFault", type: "subType", event: "edit" },
            {
              action: "saveData",
              value: [{ option: "offensiveFoul", value: true }],
              type: "options",
              event: "edit",
            },
            { action: "sendEvent", value: "edit", type: "edit" },

            { action: "copyEvent", value: "edit", type: "from" },
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "newEventId", value: null, type: "main" },
            {
              action: "clearData",
              value: ["personId", "flagged", "scores", "success", "status", "options"],
              type: "main",
            },
            { action: "saveData", value: "foul", type: "eventType" },
            { action: "saveData", value: "drawn", type: "subType" },
            {
              action: "saveData",
              value: [{ option: "offensive", value: true }],
              type: "options",
            },
            { action: "sendEvent", value: "new", type: "main" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [
            { item: "subType", value: "offensiveFoul", event: "edit", operator: "is" },
            { item: "options", value: "offensiveFoul", event: "edit", operator: "not" },
          ],
        },
        {
          actions: [
            { action: "saveData", value: "ruleFault", type: "subType", event: "edit" },
            {
              action: "saveData",
              value: [{ option: "offensiveFoul", value: true }],
              type: "options",
              event: "edit",
            },
            { action: "sendEvent", value: "edit", type: "edit" },
            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [
            { item: "subType", value: "offensiveFoul", event: "edit", operator: "is" },
            { item: "options", value: "offensiveFoul", event: "edit", operator: "is" },
          ],
        },
        {
          actions: [
            { action: "copyEvent", value: "fault", type: "to" },
            {
              action: "deleteFromPlay",
              value: "foul",
              subType: "drawn",
              type: "edit",
              options: ["all"],
              eventOptions: [{ option: "offensive", value: true }],
            },
            { action: "deleteFromPlay", value: "technicalFault", type: "main" },

            { action: "clearData", value: ["subType", "options"], type: "main" },

            { action: "newEventId", value: null, type: "main" },
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "saveData", value: "turnover", type: "eventType" },
            { action: "sendEvent", value: "new", type: "main" },

            { action: "newEventId", value: null, type: "main" },
            { action: "modifyEvent", value: "swapEntities", type: "main" },
            { action: "saveData", value: "steal", type: "eventType" },
            { action: "copyData", type: "fault", value: "personId" },
            { action: "sendEvent", value: "new", type: "main" },

            { action: "nextState", value: null, type: "editState" },
          ],
          conditions: [
            { item: "subType", value: "steal", event: "edit", operator: "is" },
          ],
        },
      ],
    },
  ],
};
